<template>
    <!-- Footer -->
    <footer>
        <div class="row p-0 g-0">
            <div class="footer">
                <a href="#"><img :src="`${publicPath}img/RocaGroupMemoriaAnual2021${locale}.svg`" width="160"></a>
            </div>
        </div>
    </footer>
    <!-- Footer -->
</template>

<script>
    export default {
        name: "FooterView",
        data () {
            return {
                publicPath: process.env.BASE_URL,
                isEs:true,
                isEn: false,
                locale: this.$i18n.locale,
            }
        },
      created() {
        // Remove show class from collapsible element to close movile menu
        this.$router.afterEach(() => {
          this.isEs = this.$i18n.locale=="es" ? true : false;
          this.isEn = this.$i18n.locale=="en" ? true : false;
          this.locale = this.$i18n.locale;
          if(this.isEn){
            this.backgroundUrl = '@/img/RocaGroupMemoriaAnual2021en.svg';
          }
        });
      },
    };
</script>
